import { useReducer } from "react";
import customerActions from "./customerActions";
import customerReducer from "./customerReducer";


export default function useCustomer() {
  const [customer, customerDispatch] = useReducer(customerReducer, {});
  const { getLocation, setLocation } = customerActions(customerDispatch);

  return {
    response: customer,
    getLocation,
    setLocation
  };
}
